import { HttpGateway } from '@mojility/coach-core'

export default class WorkspaceGateway extends HttpGateway {

  constructor(coachHttpClientFactory) {
    super(coachHttpClientFactory);
  }

  questionnairesOfWorkspace(secretKey, workspaceId) {
    return this.authenticatedGet(secretKey, `workspace/${workspaceId}/questionnaires`);
  }

  addQuestionnaire(secretKey, workspaceId, questionnaireId) {
    return this.authenticatedPut(secretKey, `workspace/${workspaceId}/questionnaires/${questionnaireId}`);
  }

  removeQuestionnaire(secretKey, workspaceId, questionnaireId) {
    return this.authenticatedDelete(secretKey, `workspace/${workspaceId}/questionnaires/${questionnaireId}`);

  }

  purchaseQuestionnaire(secretKey, workspaceId, questionnaireId, stripeToken) {
    return this.authenticatedPost(secretKey, `workspace/${workspaceId}/questionnaires/${questionnaireId}`, {
      stripe_token: stripeToken
    });
  }

  getWorkspace(secretKey, workspaceId) {
    return this.authenticatedGet(secretKey, `workspace/${workspaceId}`);
  }

}